import http from "./httpService";
import config from "../config.json";

const apiEndpoint = config.apiEndpoint + "/match-bets";

export async function getMatchBets(userId) {
  const response = await http.get(apiEndpoint + "/" + userId);
  return response.data;
}

export async function saveMatchBet(bet) {
  let betInDb = bet || {};

  if (betInDb.id === -1) await http.post(apiEndpoint, betInDb);
  else await http.put(apiEndpoint + "/" + betInDb.id, betInDb);

  return betInDb;
}



// WEBPACK FOOTER //
// ./src/services/matchBetService.js